module.exports = __webpack_public_path__ + "img/high_alert_v1.d1b0b41.svg";